/* import __COLOCATED_TEMPLATE__ from './marketing-confirm-campaign-cancellation-body.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();